import { render } from "./FontAwesomeIconComponent.vue?vue&type=template&id=a39c9136"
import script from "./FontAwesomeIconComponent.vue?vue&type=script&lang=js"
export * from "./FontAwesomeIconComponent.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/src/services/admin/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__